module.exports = __webpack_public_path__ + "img/李永涛.d9fa1de9.jpg";